const AUTH_KEY = "auth";
const AUTH_FLAG = "isAuthenticated";

export const getStoredUser = () => {
    const stored = localStorage.getItem(AUTH_KEY);
    return stored ? JSON.parse(stored) : {
        id: null,
        site: null,
        compCd: null,
        loginId: null,
        userNm: null,
        userEmail: null,
        userRole: null,
        roleNm: null,
        priorityLevel: null,
    };
};

export const storeUser = (user) => {
    localStorage.setItem(AUTH_KEY, JSON.stringify(user));
    if (user.id !== null) {
        localStorage.setItem(AUTH_FLAG, "true");
    } else {
        localStorage.removeItem(AUTH_FLAG);
    }
};

export const clearStoredUser = () => {
    localStorage.removeItem(AUTH_KEY);
    localStorage.removeItem(AUTH_FLAG);
};